import {
  type SubjectVariableLegacy,
  type DSLValueLegacy,
  SubjectVariableTypeLegacy,
} from '@verantos-dev/types-cohorts';

export const transformSubjectVariableToDsl = ({
  id,
  name,
  type,
  conceptFilters,
  numericFilters,
  countFilter,
}: SubjectVariableLegacy): DSLValueLegacy => {
  const subjectVariableName = `SUBJECTS_VARIABLE::"${name}"`;

  // Determine the type string for the query
  let typeString = '';
  switch (type) {
    case SubjectVariableTypeLegacy.DEMOGRAPHICS: {
      typeString = 'PERSON';
      break;
    }
    case SubjectVariableTypeLegacy.COUNT: {
      typeString = 'COUNT';
      break;
    }
  }

  // Build the query
  const baseQuery = `${subjectVariableName} = ${typeString} `;

  const conceptFilterQueries =
    conceptFilters?.length === 0
      ? ''
      : conceptFilters?.map(({ inputFields }) => {
          const conceptFilterQuery = inputFields?.map((inputField) => inputField.value).join(' ');
          return `CF ( ${conceptFilterQuery} )`;
        });

  const numericFilterQueries =
    numericFilters?.length === 0
      ? ''
      : numericFilters?.map(({ inputFields }) => {
          const numericFilterQuery = inputFields?.map((inputField) => inputField.value).join(' ');
          return `NF ( ${numericFilterQuery} )`;
        });

  // placing in array for easier concatenation with other filters, this should only be a single instance
  const countFilterQuery = countFilter
    ? [
        countFilter.inputFields
          .map((inputField) => {
            if (
              [
                'MERGED_EVENT',
                'SEQUENCE_EVENT',
                'INSTANCE_EVENT',
                'CONDITION_OCCURRENCE',
                'DRUG_EXPOSURE',
                'MEASUREMENT',
                'OBSERVATION',
                'PROCEDURE_OCCURRENCE',
                'VISIT_OCCURRENCE',
              ].includes(inputField.value?.split('::')[0] || '')
            ) {
              return `SUBJECT_VARIABLE_${inputField.value}`;
            }
            return inputField.value;
          })
          .join(' '),
      ]
    : [];
  const filterQuery = [...conceptFilterQueries, ...numericFilterQueries, ...countFilterQuery].join(
    ', '
  );

  const closeOffQuery = ' ;\n';
  return {
    id,
    value: baseQuery + '( ' + filterQuery + ' )' + closeOffQuery,
  };
};
